export default {
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    isMarkedAsInvalid: {
      type: Boolean,
      default: false,
    },
    hideErrorsCaption: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasErrors() {
      return this.errors?.length > 0;
    },
    firstError() {
      return this.hasErrors
        ? this.errors[0]
        : null;
    },
  },
};
